import Axios from '../config/axios';

export function addEmailTemplate(formData) {
    return Axios.post(`/api/AddEmailTemplate`, formData
    ).then(response => response.data).catch(error => error);
}

export function updateEmailTemplate(formData) {
    return Axios.post(`/api/UpdateEmailTemplate`, formData
    ).then(response => response.data).catch(error => error);
}

export function downloadEmailTemplateAttachment(postdata) {
    return Axios.post(`/api/DownloadEmailTemplateAttachment`, postdata, {
        responseType: 'blob'
    }).then(response => response.data).catch(error => error);
}

export function getEmailTemplateById(templateID) {
    return Axios.get(`/api/GetEmailTemplateById`, {
        params: {
            templateID
        }
    }).then(response => response.data).catch(error => error);
}

export function addEmailTemplateAttachment(formdata) {
    return Axios.post(`/api/AddEmailTemplateAttachment`, formdata
    ).then(response => response.data).catch(error => error);
}

export function deleteEmailTemplateAttachment(formdata) {
    return Axios.post(`/api/DeleteEmailTemplateAttachment`, formdata
    ).then(response => response.data).catch(error => error);
}

//export function getEmailHistory() {
//    return Axios.get(`/api/GetEmailHistory`).then(response => response.data).catch(error => error);
//}

//export function getRepEmailTemplates(ownedby, division) {
//    return Axios.get('/api/GetRepEmailTemplates',
//        {
//            params: {
//                ownedby,
//                division
//            }
//        }).then(response => response.data).catch(error => error);
//}

//export function addRepEmailTemplate(postdata) {
//    return Axios.post(`/api/AddRepEmailTemplate`, postdata
//    ).then(response => response.data).catch(error => error);
//}

//export function updateRepEmailTemplate(postdata) {
//    return Axios.post(`/api/UpdateRepEmailTemplate`, postdata
//    ).then(response => response.data).catch(error => error);
//}

//export function deleteRepEmailTmplate(postdata) {
//    return Axios.post(`/api/DeleteRepEmailTemplate`, postdata
//    ).then(response => response.data).catch(error => error);
//}